<template lang="pug">
.layout
  header#header.f.f-sb.f-ac(
    :class="{'header_with_bg': showNavBg}"
  )
    .f.f-sb.f-ac.content
      span(@click="gotoPage('/home')")
        img.header-logo(src="@/assets/logo.png")
      .header-right
        nav
          ul.header-nav.f.f-sb
            li
            li
              span(@click="gotoPage('/home')") {{ $t('首页') }}
            el-popover(
              popper-class="product-popover"
              placement="top-end"
              width="587"
              trigger="hover"
            )
              .productList-container
                .product-item(
                  v-for="(item,idx) in productList"
                  @click="gotoPage(item.url)"
                )
                  .opacity-black
                    a(:style="{'background':(idx===0)?'#FFF':'none'}")
                      img(
                        :src="item.img"
                      )
                  div(style="margin-left:24px")
                    .title {{ $t(item.name) }}
                    .desc {{ $t(item.desc) }}
              li(slot="reference")
                span {{ $t('产品') }}
                img(src="@/assets/icon-dropdown.png")
                //- i.iconfont.iconxiala1

            el-popover(
              popper-class="service-popover"
              placement="top"
              width="246"
              trigger="hover"
            )
              .serviceList-container
                .service-item(
                  v-for="(item,idx) in serviceList"
                  @click="$router.push(item.url)"
                )
                  img(
                    :src="item.img"
                  )
                  .title {{ $t(item.name) }}

              li(slot="reference")
                span {{ $t('服务') }}
                img(src="@/assets/icon-dropdown.png")
                //- i.iconfont.iconxiala1
            li
              span(@click="gotoPage('/about')") {{ $t('关于复歌') }}
        //- span.header-lang
        //-   span.header-lang__item 中
        //-   span /
        //-   span.header-lang__item ENG
  router-view
  footer
    page-footer
</template>

<script>
import db from '@/db'
import PageFooter from '@/components/PageFooter'

export default {
  components: {
    PageFooter
  },
  data () {
    return {
      showNavBg: false,
      manual_url: null,
      visible: false,
      serviceList: [
        {
          name: '营销人才服务',
          img: require('@/assets/service_new01.png'),
          url: '/service/financial-service'
        },
        {
          name: '广告运营',
          img: require('@/assets/service_2.png'),
          url: '/service/ad-marketing'
        },
        {
          name: '资源直采',
          img: require('@/assets/service_3.png'),
          url: '/service/resource-purchasing'
        },
        {
          name: '媒体审计',
          img: require('@/assets/service_4.png'),
          url: '/service/price-auditing'
        },
        {
          name: '数字化管理',
          img: require('@/assets/service_5.png'),
          url: '/service/digital-management'
        },
        {
          name: '效果评估',
          img: require('@/assets/service_6.png'),
          url: '/service/effect-evaluation'
        }
      ],
      productList: [
        {
          name: '好快活',
          img: require('@/assets/happy-logo.png'),
          desc: '营销人才管理',
          url: '/product/happy'
        },
        {
          name: 'Rimix',
          img: require('@/assets/nav-rimix-logo.png'),
          desc: '营销投资管理',
          url: '/product/rimix'
        },
        {
          name: 'Libra',
          img: require('@/assets/nav-libra-logo.png'),
          desc: 'KOL投放分析',
          url: '/product/libra'
        },
        {
          name: 'Data Hub',
          img: require('@/assets/nav-datahub-logo.png'),
          desc: '营销数据洞察',
          url: '/product/data_hub'
        },
        {
          name: 'Bid Agent',
          img: require('@/assets/nav-bidagent-logo.png'),
          desc: '搜索广告管理',
          url: '/product/bid_agent'
        },
        {
          name: 'iMedia Matrix',
          img: require('@/assets/nav-mediaMatrix-logo.png'),
          desc: '媒介数据审计',
          url: '/product/i_media_matrix'
        },
        {
          name: '贵了么',
          img: require('@/assets/nav-guileme-logo.png'),
          desc: '营销资源市场',
          url: '/product/guileme'
        },
        {
          name: 'iMedia Tracker',
          img: require('@/assets/nav-tracker-logo.png'),
          desc: '营销活动管理',
          url: '/product/i_media_tracker'
        }
      ]
    }
  },
  mounted () {
    if (this.$route.path.includes('/case') || window.scrollY > 0) {
      this.showNavBg = true
    } else {
      this.showNavBg = false
    }
    window.addEventListener('scroll', () => {
      if (this.$route.path.includes('/case') || window.scrollY > 0) {
        this.showNavBg = true
      } else {
        this.showNavBg = false
      }
    })
  },
  computed: {
    lang () {
      return db.lang
    },
    user () {
      return this.$store.getters.user
    },
    bannerStr () {
      // is_completed 是否入库完成
      return ''
    }
  },
  methods: {
    gotoPage (src) {
      this.$router.push(src)
    },
    gotoLink (link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="stylus">
html
  overflow-y scroll

body
div
dl
dt
dd
ul
ol
li
h1
h2
h3
h4
h5
h6
pre
code
form
fieldset
legend
input
button
textarea
p
blockquote
th
td
  margin: 0
  padding: 0

body
  // min-width 1440px
  background: #fff
  color: #555
  font-size: 14px
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif
td
th
caption
  font-size: 14px

h1
h2
h3
h4
h5
h6
  font-weight: normal
  font-size: 100%

address
caption
cite
code
dfn
em
strong
th
var
  font-style: normal
  font-weight: normal

a
  color: #555
  text-decoration: none

a:hover
  text-decoration: none

img
  border: none

ol
ul
li
  list-style: none

input
textarea
select
button
  font: 14px Verdana, Helvetica, Arial, sans-serif

table
  border-collapse: collapse

input::placeholder
  color: rgba(255, 255, 255, 0.5)

input:focus::-webkit-input-placeholder
  color: transparent

input[type=email]:focus
  background-color: rgba(44, 165, 190, 1)
  outline: none

.f
  display: flex

.f-fc
  flex-direction: column

.f-jc
  justify-content: center

.f-ac
  align-items: center

.f-sb
  justify-content: space-between

.f-sa
  justify-content: space-around

.content
  width: 100%

.min-content
  width: 100%
  padding 0 87px
  box-sizing border-box

.button
  width: 171px
  height: 51px
  display: block
  line-height: 51px
  text-align: center
  border-radius: 100px
  border: solid 2px #4e89c9
  transition: all 0.3s ease-out
  cursor pointer

.button:hover
  color: #fff
  border: solid 2px #f4f3f3
  background: linear-gradient(101deg, #3dbdb6, #0089ce)

#header
  position fixed
  top 0
  left 0
  right 0
  height: 52px
  padding: 10px 48px
  z-index 9
.header_with_bg
  background: url("../../../assets/nav-bar-bg.png") no-repeat
  background-size cover
.header-logo
  cursor pointer
  height: 32px
  transform: scale(0.8) translateY(3px)

.header-right
  display: flex
  align-items: center

.header-lang
  color #fff
  border-bottom: solid 1px rgba(0 , 0 , 0, 0)
  cursor pointer
  > span:nth-child(2)
    margin 0 5px
  > .active
    color: #3ec3e7

.header-nav
  align-items center
  li
    font-size 18px
    display: flex
    align-items center
    justify-content: center
    margin-left: 70px
    transition: 0.3s
  img
    width 9px
    height 6px
    margin-left 8px
// .header-nav > li.active,
// .header-nav > li:hover
//   border-bottom: solid 1px #fff

.header-nav
  li
    > span
      color: #fff
      display: block
      margin-top: 5px
      margin-bottom: 5px
      cursor pointer
    i
      color #fff

.header-nav > li.active > span
  color: #4a4a4a

.opacity-black { width: 48px; height: 48px; background-color: #000;border-radius: 6px }
.opacity-black a { transition: opacity .5s; opacity: 1; }

.product-popover
  padding 40px !important
  padding-bottom 0 !important
  height 395px
  box-sizing border-box
  .productList-container
    flex-wrap wrap
    display flex
    .product-item
      width 50%
      display flex
      justify-content flex-start
      margin-bottom 40px
      cursor pointer
      &:hover
        a
          opacity: 0.9
        .title
          color #4b8ecb
      img
        width 48px
        height 48px
      > div
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .title
          font-size 18px
          color $black-title
        .desc
          font-size 16px
          color $black-content

.service-popover
  padding 40px !important
  padding-bottom 0 !important
  height 394px
  box-sizing border-box
  .serviceList-container
    .service-item
      display flex
      cursor pointer
      align-items center
      margin-bottom 32px
      img
        width 20px
        height 20px
      .title
        margin-left 16px
        font-size 18px
        color $black-title
        // font-weight 600
        &:hover
          color $blue-hover
#footer
  visibility: hidden
  transition: all 0.5s
  height: 40px
  width: 100%
  // background: url("@/assets/common/footer-bg.png") no-repeat
  background-size: cover
  z-index: 9

#footer p
  color: #fff

.footer__email
  width: 302px
  border-radius: 3px
  background-color: transparent
  color: #fff
  box-shadow: 0 0 8px 0 rgba(176, 176, 176, 0.5)
  padding-top: 3px
  padding-bottom: 3px
  border: solid 1px #ffffff
  text-indent: 10px
  font-size: 12px
  height: 17px

.footer__submit
  width: 120px
  height: 25px
  border: none
  outline: none
  border-radius: 4px
  cursor: pointer
  color: #4a90e2
  font-size: 12px
  background-color: #ffffff
  transform: translateX(-8%)

.footer__successful
  color: #fff
  display: none

.footer__close
  position: absolute
  cursor: pointer
  right: 20px
  top: 10px
  font-size: 20px
  width: 20px
  transition: 0.3s

.footer__close:hover
  transform: scale(1.5, 1.5)

#address
  padding-top: 50px
  padding-bottom: 50px
  min-height: 200px
  // background: url("@/assets/common/address-bg.png") no-repeat
  background-size: cover

.address__main
  width 699px
  font-size: 12px
  line-height: 2.33

.privacy__content
  color: rgba(255, 255, 255, 0.6)
  border-top: 1px solid rgba(255, 255, 255, 0.6)
  margin-top: 15px
  display: flex
  a
    color:rgba(255, 255, 255, 0.6)
    img
      width: 15px
  &:hover
    color: #fff
  > span
    margin-left: 10px
    cursor pointer

.address__content li
  padding-top: 3px
  padding-bottom: 3px

.address__link
  width: 200px

.address__link > li:first-child
  color: #fff
  border-bottom: 1px solid rgba(255, 255, 255, 0.6)

.address__link span
  cursor pointer
  color: rgba(255, 255, 255, 0.6)

.address__link span:hover
  color: #fff

.address__info
  flex 1
  color: rgba(255, 255, 255, 0.6)

.address__info a
  color: rgba(255, 255, 255, 0.6)

.address__info a:hover
  color: #fff

.address__info > li:first-child
  color: #fff
  border-bottom: 1px solid  rgba(255, 255, 255, 0.6)

.address__qrcode
  margin-top 40px

.address__qrcode img
  width: 152px
  height: 152px

.address__qrcode p
  text-align: center
  margin-top: 10px
  font-size: 13px
  color: #fff

.animated
  animation-duration: 2s
  animation-fill-mode: both
  opacity: 0

.animatedRight
  animation-duration: 2s
  animation-fill-mode: both
  opacity: 0

.fadeInUp
  animation-name: fadeInUp

.fadeInRight
  animation-name: fadeInRight

@keyframes fadeInUp
  0%
    opacity: 0
    transform: translate3d(0, 100%, 0)
  100%
    opacity: 1
    transform: none

@keyframes fadeInRight
  0%
    opacity: 0
    transform: translate3d(-200px, 0, 0)
  100%
    opacity: 1
    transform: none

@keyframes scroll-wheel
  0%
    transform: translate3d(0, 0, 0)
    opacity: 1
  50%
    transform: translate3d(0, 5px, 0)
    opacity: 1
  100%
    transform: translate3d(0, 0, 0)
    opacity: 1

.lang-en .address__info
  width: 355px
</style>
